module.exports = __webpack_public_path__ + "static/media/wine.5c59b6d8.svg";